import type { Highlight } from '../../interface/Program';
import type { Paginated } from '@/interface/Paginate';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getHighlightedContents = async (context: Context = 'home') => {
  const params = {
    page: 1,
    limit: 10,
  };

  const authToken = getCookie(authKeys.authToken);
  const urlFetchHighlightsContents = authToken
    ? mapContext[context]
    : mapContextPublic[context];

  const { data } = await api.get<Paginated<HighlightedContentsAPIResponse>>(
    urlFetchHighlightsContents,
    { params }
  );

  return data.data;
};

export const useGetHighlightedContents = (context: Context) =>
  useQuery({
    queryKey: ['highlighted', 'contents', context],
    queryFn: () => getHighlightedContents(context),
  });

type HighlightedContentsAPIResponse = {
  id: string;
  items: Highlight[];
  title: string;
};

const mapContext = {
  home: apiConfig.routes.home.highlights,
  research: apiConfig.routes.research.highlights,
} as const;

const mapContextPublic = {
  home: apiConfig.routes.home.highlightsPublic,
  research: apiConfig.routes.research.highlightsPublic,
} as const;

type Context = keyof typeof mapContext;
